import React, { Component } from 'react';
import MultiSelectExtended from 'components/shared/MultiSelectExtended';

class PropertyMultiSelect extends Component {
  render() {
    return (
      <MultiSelectExtended
        onChange={this.props.onPropertySelect}
        multiple={!this.props.disableMultiple}
        name="property_select"
        hintText={this.props.verbiage || 'Select properties to filter'}
        data={this.props.properties}
        menuStyle={{ fontSize: '14px' }}
        textFieldStyle={{ padding: 0 }}
        style={{ fontSize: '14px' }}
        minHeight={'32px'}
        fullWidth
        fireOnChangeIfBlank
        withResetSelectAllButtons
        value={this.props.selectedProperties}
      />
    );
  }
}

export default PropertyMultiSelect;
